import { Grid, Paper } from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import { IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE } from "../../../constants/signalRequestConsts";
import { getEmployeesInMyCharge, getEmployeesToApprove } from "../../../api/s10OrganizationApi";
import { searchInMyChargeEmployeesContracts, setInMyChargeEmployeeContractsReset } from "../../../store/slices/userRequests";
import TableEmployeesContracts from "./TableEmployeesContracts";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// 0: todos los tipos de cupones
// -1: solo vacaciones sunat
// -2: todo menos vacaciones sunat
// viewType = All, InMyCharge, ToApprove

const ManagementEmployeesContracts = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [rucSelected, setRucSelected] = useState<string>("")
    const [errorMsg, setErrorMsg] = useState<string>("")

    const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
    const [descriptionOne, setDescriptionOne] = useState<string>("")
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageOne, setPageOne] = useState<number>(2)
    
    // const [orderedEmployees, setOrderedEmployees] = useState<{ [key: string]: Employee[] }>({})

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected) {
            return;
        }
        getInitialTablesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected]);

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableOneRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionOne, pageSizeOne, pageOne, employeesCodes]);


    const getInitialTablesData = async () => {

        let _employeesCodes =  "";
        dispatch(setInMyChargeEmployeeContractsReset(IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE));
        setEmployeesCodes(null);
        const finalRuc = rucSelected === "all" ? "" : rucSelected;
        if (viewType === "InMyCharge") {
            const result = await getEmployeesInMyCharge(finalRuc);
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado en el organigrama")
                return;
            }
            _employeesCodes = result?.data.join(",")
        } else if (viewType === "ToApprove") {
            const result = await getEmployeesToApprove();
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado a tu grupo de aprobacion")
                return;
            }
            _employeesCodes = result?.data.join(",")
        }
        setEmployeesCodes(_employeesCodes);
    }

    const tableOneRequest = () => 
        dispatch(searchInMyChargeEmployeesContracts(
            IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE,
            employeesCodes as any,
            rucSelected,
            0,
            descriptionOne,
            pageSizeOne,
            pageOne,
        ));


    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={'all'}
            />
            <TableEmployeesContracts 
                rucEmpresa={rucSelected}
                requestId={IN_MY_CHARGE_EMPLOYEES_CONTRACTS_ONE}
                page={pageOne}
                setPage={setPageOne}
                description={descriptionOne}
                setDescription={setDescriptionOne}
                pageSize={pageSizeOne}
                setPageSize={setPageSizeOne}
            />
        </Paper>
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default ManagementEmployeesContracts;